import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-main-procrea',
  imports: [RouterOutlet],
  templateUrl: './main-procrea.component.html',
  styleUrl: './main-procrea.component.scss'
})
export class MainProcreaComponent {}
